import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, map, tap } from 'rxjs/operators';
import { getImportSettingsActionState } from 'landlord/+state/import-settings/import-settings.selectors';
import { FetchImportSettings } from 'landlord/+state/import-settings/import-settings.actions';
import { ActionStateCreator } from '@ui/legacy-lib';

export const ImportSettingsGuard = () => {
  const store = inject(Store);

  return store.select(getImportSettingsActionState).pipe(
    tap(state => {
      if (ActionStateCreator.isInitialState(state)) {
        store.dispatch(FetchImportSettings());
      }
    }),
    filter(state => !state.pending),
    map(() => true)
  );
};
